const CURRENCY_SYMBOLS: Record<string, string> = {
    EUR: '€',
    USD: '$',
    GBP: '£'
}

// Deterministic price formatting (e.g. "€ 3,50"). Intl.NumberFormat with "sq-AL" is avoided on
// purpose: the server's ICU may lack Albanian data and render differently from the browser.
export const formatPrice = (value: number, currency = 'EUR'): string => {
    const symbol = CURRENCY_SYMBOLS[currency] ?? currency
    const formatted = value.toFixed(2).replace('.', ',')

    return `${symbol} ${formatted}`
}
